export default {
  instrumentCategories: {
    results: [],
  },
  instrumentsStateModel: {
    results: [],
  },
  instrumentsStateModelVariant: {
    results: [],
  },
  instrumentsForEntering: {
    results: [],
  },
  instrumentRemains: [],
  instrumentModalDetails: [],

  instrument_for_builds: {
    results: []
  },
}
